export default [
  { title: "Pendahuluan", icon: "ri-home-4-line", link: "/" },
  // { title: "Overview", icon: "ri-home-4-line", link: "/" },
  // { title: "Deposit", icon: "ri-wallet-line", link: "/deposit" },
];
